import axios from 'axios';

export const baseUrl = 'https://api.pakraillive.com'
export const extBaseUrl = 'https://cotrolroomapi.pakraillive.com'

export const extInstance = axios.create({
  baseURL: baseUrl + '/api'
});

const instance = axios.create({
  baseURL: extBaseUrl
});

instance.interceptors.request.use((request) => {

  let user = JSON.parse(localStorage.getItem('user'))

  request.headers = {
    'Accept': "application/json, text/plain, */*",
    'Authorization': `Bearer ${user?.access_token}`,
    // 'Access-Control-Allow-Origin': "*",
    'Content-Type': 'application/x-www-form-urlencoded',
  }
  return request
});

instance.interceptors.response.use((response) => {
  if (response) {
    return response
  }
}, (error) =>
  Promise.reject(
    error
  )
);

export default instance;